export const HAMS = 'HAMS';
export const CCP = 'CCP';

export const JiraMessageKeysWithIssueTerm = [
	'benefitsBulletJiraSync',
	'benefitsBulletJiraIssues',
	'benefitsBulletJiraAutomatically',
	'benefitsBulletJiraProcess',
	'benefitsBulletJiraUnlock',
];

export const JiraMessageKeys = [
	'benefitsBulletJiraSync',
	'benefitsBulletJiraIssuesIssueTermRefresh',
	'benefitsBulletJiraAutomaticallyIssueTermRefresh',
	'benefitsBulletJiraProcess',
	'benefitsBulletJiraUnlock',
];

export const ConfluenceMessageKeysSpork = [
	'benefitsBulletConfluenceShareSpork',
	'benefitsBulletConfluenceSpend',
	'benefitsBulletConfluenceCreate',
	'benefitsBulletConfluenceUnlock',
];

export const JSWKey = 'jira-software.ondemand';

export const JSMKey = 'jira-servicedesk.ondemand';

export const ConfluenceKey = 'confluence.ondemand';

export const MULTI_PRODUCT_UPGRADE_MSG_ID = 'multi-product-upgrade-enhancement';
export const MULTI_PRODUCT_UPGRADE_MSG_ID_STG = 'multi-product-upgrade-enhancement-stg';
